export const palette = {
  blue900: "#0A2540",
  blue800: "#08204A",
  blue700: "#0C3C84",
  blue600: "#10356E",
  blue500: "#184890",
  blue400: "#123A76",
  blue100: "#E8EEF8",
  blue050: "#F1F4F8",
  gold600: "#9C7616",
  gold500: "#E4C03C",
  gold100: "#FAF2DA",
  grey900: "#121824",
  grey700: "#576073",
  grey500: "#8891A1",
  grey400: "#AEBACB",
  grey300: "#CBD4E0",
  grey250: "#D2D9E3",
  grey225: "#DCE2EA",
  grey200: "#E3E8EF",
  grey150: "#EDF1F6",
  grey100: "#F3F6F9",
  grey050: "#FAFBFD",
  white: "#FFFFFF",
  ink: "#101824",
  red600: "#A93B2D",
  red200: "#EFD3CE",
  red100: "#FBECE9",
  rowHover: "#F7FAFD",
  goldMedalLight: "#F0D780",
  goldMedalDark: "#D6AE36",
  goldMedalInk: "#3A2C08",
  silverLight: "#E4E8EE",
  silverDark: "#AEB6C2",
  silverInk: "#262C34",
  bronzeLight: "#D9AE84",
  bronzeDark: "#AB7A4E",
  bronzeInk: "#3A2410",
};

export const colors = {
  background: palette.grey100,
  surface: palette.white,
  surfaceSubtle: palette.grey050,
  border: palette.grey200,
  borderStrong: palette.grey250,
  text: palette.grey900,
  textSecondary: palette.grey700,
  textTertiary: palette.grey500,
  textOnBrand: palette.white,
  primary: palette.blue500,
  primaryHover: palette.blue400,
  primaryDeep: palette.blue700,
  primarySoft: palette.blue100,
  primaryWash: palette.blue050,
  accent: palette.gold500,
  accentText: palette.gold600,
  accentSoft: palette.gold100,
  danger: palette.red600,
  dangerSoft: palette.red100,
  dangerBorder: palette.red200,
  success: palette.blue500,
  successSoft: palette.blue100,
  rowHover: palette.rowHover,
  rowSelected: palette.blue100,
  tooltipBackground: palette.ink,
  tooltipText: palette.white,
};

export const radius = { card: 10, control: 8, small: 5 };
export const layout = { sidebar: 268, sidebarRail: 74, topbar: 60 };

export const fontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Inter, Roboto, "Helvetica Neue", Arial, sans-serif';

// GlobalStyles publishes these stable names for regular CSS consumers.
// Change values above, not the custom-property names below.
export const cssVariables = {
  "--simcc-blue-900": palette.blue900,
  "--simcc-blue-800": palette.blue800,
  "--simcc-blue-700": palette.blue700,
  "--simcc-blue-600": palette.blue600,
  "--simcc-blue-500": palette.blue500,
  "--simcc-blue-400": palette.blue400,
  "--simcc-blue-100": palette.blue100,
  "--simcc-blue-050": palette.blue050,
  "--simcc-gold-600": palette.gold600,
  "--simcc-gold-500": palette.gold500,
  "--simcc-gold-100": palette.gold100,
  "--simcc-grey-900": palette.grey900,
  "--simcc-grey-700": palette.grey700,
  "--simcc-grey-500": palette.grey500,
  "--simcc-grey-400": palette.grey400,
  "--simcc-grey-300": palette.grey300,
  "--simcc-grey-250": palette.grey250,
  "--simcc-grey-225": palette.grey225,
  "--simcc-grey-200": palette.grey200,
  "--simcc-grey-150": palette.grey150,
  "--simcc-grey-100": palette.grey100,
  "--simcc-grey-050": palette.grey050,
  "--simcc-white": palette.white,
  "--simcc-ink": palette.ink,
  "--simcc-red-600": palette.red600,
  "--simcc-red-200": palette.red200,
  "--simcc-red-100": palette.red100,
  "--simcc-gold-medal-light": palette.goldMedalLight,
  "--simcc-gold-medal-dark": palette.goldMedalDark,
  "--simcc-gold-medal-ink": palette.goldMedalInk,
  "--simcc-silver-light": palette.silverLight,
  "--simcc-silver-dark": palette.silverDark,
  "--simcc-silver-ink": palette.silverInk,
  "--simcc-bronze-light": palette.bronzeLight,
  "--simcc-bronze-dark": palette.bronzeDark,
  "--simcc-bronze-ink": palette.bronzeInk,
  "--color-background": colors.background,
  "--color-surface": colors.surface,
  "--color-surface-subtle": colors.surfaceSubtle,
  "--color-border": colors.border,
  "--color-border-strong": colors.borderStrong,
  "--color-text": colors.text,
  "--color-text-secondary": colors.textSecondary,
  "--color-text-tertiary": colors.textTertiary,
  "--color-text-on-brand": colors.textOnBrand,
  "--color-primary": colors.primary,
  "--color-primary-hover": colors.primaryHover,
  "--color-primary-deep": colors.primaryDeep,
  "--color-primary-soft": colors.primarySoft,
  "--color-primary-wash": colors.primaryWash,
  "--color-accent": colors.accent,
  "--color-accent-text": colors.accentText,
  "--color-accent-soft": colors.accentSoft,
  "--color-danger": colors.danger,
  "--color-danger-soft": colors.dangerSoft,
  "--color-danger-border": colors.dangerBorder,
  "--color-success": colors.success,
  "--color-success-soft": colors.successSoft,
  "--color-row-hover": colors.rowHover,
  "--color-row-selected": colors.rowSelected,
  "--color-tooltip-background": colors.tooltipBackground,
  "--color-tooltip-text": colors.tooltipText,
  "--radius-card": `${radius.card}px`,
  "--radius-control": `${radius.control}px`,
  "--radius-small": `${radius.small}px`,
  "--shadow-small": "0 1px 2px rgba(18, 24, 36, 0.06)",
  "--shadow-medium": "0 14px 36px -10px rgba(18, 24, 36, 0.28)",
  "--shadow-drawer": "-18px 0 44px -22px rgba(18, 24, 36, 0.4)",
  "--layout-sidebar-width": `${layout.sidebar}px`,
  "--layout-sidebar-rail-width": `${layout.sidebarRail}px`,
  "--layout-topbar-height": `${layout.topbar}px`,
  "--font-sans": fontFamily,
  "--font-mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
};
